export const set = (target, key, value) => {
  target[key] = value;
};

export const del = (target, key) => {
  delete target[key];
};
